"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/**
 * track events in moengage
 * @param {String} event string
 * @param {Object} attributes object
 *
 */
function trackEvent(data) {
    if (global.Moengage) {
        const { event } = data, attributes = __rest(data, ["event"]);
        const attributesList = !(0, isEmpty_1.default)(attributes) ? attributes : undefined;
        global.Moengage.track_event(event, attributesList);
    }
}
exports.default = trackEvent;
